export default __webpack_public_path__ + "static/media/Discharging.3e1475ab.svg";